export default __webpack_public_path__ + "static/media/uniwallet.60e5d1e2.svg";